import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useWatch } from 'react-hook-form';
import { FormSchemaCreate } from './type';

import { useGetSpecAndPricingInstanceGPU } from '@/service/one-click-deploy/hook';
import { OptimizationTechnique, OptimizationTechniqueLabel } from '@/service/one-click-deploy/type';

const DisplaySummary = () => {
  const { huggingFace, instance } = useWatch<FormSchemaCreate>();
  const { data } = useGetSpecAndPricingInstanceGPU();
  const result = data?.find((item) => item.pricing_id === instance?.gpu);

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Instance Summary</CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground">
          <div className="grid gap-1">
            <p>Repository: {huggingFace?.link}</p>
            <p>GPU: {result?.gpu_name} · {result?.vram} GB VRAM</p>
            <p>
              Optimization Technique:{' '}
              {OptimizationTechniqueLabel?.[
                instance?.optimizationTechnique as OptimizationTechnique
              ] || instance?.optimizationTechnique as string}
            </p>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default DisplaySummary;
